import React from "react";
import { Icons } from "../components/Icons";
import ImageWithFallback from '../components/UI/ImageWithFallback';

const About = ({ go }) => {
  return (
    <>
      <div className="page-hero">
        <div className="wrap page-hero-inner">
          <div className="breadcrumb">
            <span>Home</span>
            <Icons.ChevronRight size={12} />
            <em>About Us</em>
          </div>
          <span className="badge badge-blue">About NewCover Ltd</span>
          <h1>
            Your Trusted Global B2B
            <br />
            Electronics Supplier
          </h1>
          <p>
            Founded in 2016, we've served multiple businesses across multiple countries
            with competitive wholesale pricing and reliable supply chain
            solutions.
          </p>
        </div>
      </div>

      <section className="section">
        <div className="wrap">
          <div className="about-grid">
            <div className="about-img-wrap">
              <div className="about-img-main">
                <ImageWithFallback
                  src="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=700&q=85"
                  alt="Operations"
                />
              </div>
              <div className="about-img-secondary">
                <ImageWithFallback
                  src="https://images.unsplash.com/photo-1498049794561-7780e7231661?w=400&q=85"
                  alt="Products"
                />
              </div>

            </div>
            <div>
              <span className="badge badge-blue">Company Overview</span>
              <h2 className="sh-title">Who We Are</h2>
              <p style={{ marginTop: 12 }}>
                NewCover Ltd is a premium wholesale electronics distributor
                specializing in B2B supply for retailers, e-commerce operators,
                corporate procurement teams, and regional distributors
                worldwide.
              </p>
              <p style={{ marginTop: 10 }}>
                We maintain direct relationships with authorized manufacturers
                and distributors across Asia, Europe, and North America —
                ensuring authentic products at the most competitive wholesale
                prices.
              </p>
              <div className="check-list">
                {[

                  "Authorized reseller for multiple global brands",
                  "Dedicated B2B account manager per client",
                  "Custom sourcing for any product not in catalog",
                  "Complete customs and export documentation service",
                  "Net-30 payment terms for qualified accounts",
                ].map((item, i) => (
                  <div key={i} className="check-item">
                    <Icons.CheckCircle size={15} color="#16a34a" />
                    <span>{item}</span>
                  </div>
                ))}
              </div>
              <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                <button
                  className="btn btn-primary"
                  onClick={() => go("contact")}
                >
                  Partner With Us
                </button>
                <button
                  className="btn btn-white"
                  onClick={() => go("products")}
                >
                  View Catalog
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <div className="stats-strip">
        <div className="stats-strip-inner">
          {[
            ["2016", "Founded"],
            ["10,000+", "Products"],
            ["500+", "B2B Clients"],
            ["50+", "Countries"],
          ].map(([n, l], i) => (
            <div key={i} className="stat-item">
              <div className="stat-num">{n}</div>
              <div className="stat-label">{l}</div>
            </div>
          ))}
        </div>
      </div> */}

      <section className="section" style={{ background: "var(--gray-50)" }}>
        <div className="wrap">
          <div className="section-header center">
            <span className="badge badge-blue">Our Purpose</span>
            <h2 className="sh-title">Mission, Vision & Values</h2>
            <div className="sh-line center" />
          </div>
          <div className="mission-grid">
            {[
              {
                icon: "🎯",
                bg: "var(--blue-50)",
                title: "Our Mission",
                text: "To be the world's most dependable wholesale electronics supplier — connecting global businesses with premium products, transparent pricing, and exceptional service at scale.",
              },
              {
                icon: "🔭",
                bg: "#fffbeb",
                title: "Our Vision",
                text: "To modernize global B2B electronics distribution through trust, technology, and long-term partnership — powering businesses of all sizes to compete and grow.",
              },
              {
                icon: "💎",
                bg: "var(--green-50)",
                title: "Our Values",
                text: "Integrity in every transaction. Speed in every fulfillment. Quality in every product. We hold ourselves to the standards our clients' businesses depend on.",
              },
              {
                icon: "🤝",
                bg: "var(--orange-50)",
                title: "Our Commitment",
                text: "We invest in understanding each client's specific needs. Long-term partnerships matter more than single transactions. Your growth is our growth.",
              },
            ].map((m, i) => (
              <div key={i} className="mission-card">
                <div className="mc-icon" style={{ background: m.bg }}>
                  <span style={{ fontSize: "1.5rem" }}>{m.icon}</span>
                </div>
                <h4 style={{ marginBottom: 8 }}>{m.title}</h4>
                <p style={{ fontSize: ".86rem", lineHeight: 1.75 }}>{m.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="wrap">
          <div className="section-header center">
            <span className="badge badge-orange">What We Do</span>
            <h2 className="sh-title">Our Services</h2>
            <p className="sh-sub">
              End-to-end B2B electronics supply chain solutions — from sourcing
              to delivery.
            </p>
            <div className="sh-line center" />
          </div>
          <div className="services-grid">
            {[
              {
                n: "01",
                icon: <Icons.Package size={20} color="#2563eb" />,
                bg: "var(--blue-50)",
                bc: "var(--blue-100)",
                c: "#2563eb",
                title: "Bulk Supply",
                desc: "Order from 10 to 10,000+ units. We maintain large inventories of popular SKUs for fast turnaround on confirmed orders.",
              },
              {
                n: "02",
                icon: <Icons.Search size={20} color="#0ea5e9" />,
                bg: "#f0f9ff",
                bc: "#bae6fd",
                c: "#0284c7",
                title: "Product Sourcing",
                desc: "Can't find a product? Our global procurement team can locate any electronics product from verified, authorized sources within 48 hours.",
              },
              {
                n: "03",
                icon: <Icons.Users size={20} color="#d97706" />,
                bg: "var(--orange-50)",
                bc: "var(--orange-100)",
                c: "#d97706",
                title: "B2B Partnerships",
                desc: "Become a preferred partner. Unlock exclusive pricing tiers, dedicated support, and priority stock allocation on high-demand items.",
              },
              {
                n: "04",
                icon: <Icons.Truck size={20} color="#16a34a" />,
                bg: "var(--green-50)",
                bc: "rgba(34,197,94,.25)",
                c: "#16a34a",
                title: "Global Logistics",
                desc: "Door-to-door delivery via DHL, FedEx, or sea freight. Full customs clearance, export paperwork, and shipment tracking included.",
              },
              {
                n: "05",
                icon: <Icons.Shield size={20} color="#7c3aed" />,
                bg: "#f5f3ff",
                bc: "#ddd6fe",
                c: "#7c3aed",
                title: "Warranty & Returns",
                desc: "All products include manufacturer warranty. We manage warranty claims and returns on behalf of our B2B clients efficiently.",
              },
              {
                n: "06",
                icon: <Icons.BarChart size={20} color="#db2777" />,
                bg: "#fdf2f8",
                bc: "#fbcfe8",
                c: "#db2777",
                title: "Market Intelligence",
                desc: "Stay ahead with our curated insights on trending products, pricing shifts, and emerging tech categories in the wholesale market.",
              },
            ].map((svc, i) => (
              <div key={i} className="service-card">
                <div className="svc-num" style={{ color: svc.c }}>
                  {svc.n}
                </div>
                <div
                  className="svc-icon"
                  style={{
                    background: svc.bg,
                    borderColor: svc.bc,
                    color: svc.c,
                  }}
                >
                  {svc.icon}
                </div>
                <h4 style={{ marginBottom: 8 }}>{svc.title}</h4>
                <p style={{ fontSize: ".84rem" }}>{svc.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
